import React, { useState, useEffect, useRef } from 'react';
import RuntimeInputsDialog from './RuntimeInputsDialog';

/**
 * Edit a single variable's runtime/preview value (used in VariablePromptEditor flows).
 */
export default function VariableValueEditDialog({
  open,
  variable,
  initialValue = '',
  onClose,
  onSave,
}) {
  const [localValue, setLocalValue] = useState('');
  const debounceRef = useRef(null);

  useEffect(() => {
    if (open && variable) {
      setLocalValue(initialValue ?? '');
    }
    // Intentionally omit initialValue: only seed when opening or switching variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, variable?.name]);

  const flushSave = () => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
      debounceRef.current = null;
    }
    if (variable?.name) {
      onSave?.(variable.name, localValue);
    }
  };

  const handleClose = () => {
    flushSave();
    onClose?.();
  };

  if (!variable) return null;

  return (
    <RuntimeInputsDialog
      open={open}
      onClose={handleClose}
      title="Session input"
      confirmLabel="Done"
      showCancel={false}
      autoFocus
      variables={[variable]}
      values={{ [variable.name]: localValue }}
      onChange={(_, next) => {
        setLocalValue(next);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
          onSave?.(variable.name, next);
        }, 300);
      }}
      onConfirm={handleClose}
    />
  );
}
